var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"lazy-video-thumb",attrs:{"poster":_vm.poster,"autoplay":"","muted":"","loop":"","playsinline":"","preload":"metadata"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }